// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating vital signs payload used for admission.
 * @see #/components/schemas/AdmissionVitalSignsRequest - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface AdmissionVitalSignsRequest {
    /**
     * The mass in kg of the patient.
     * @dataFormat double
     */
    weight_in_kg: number;
    /**
     * The height in cm of the patient.
     * @dataFormat double
     */
    height_in_cm: number;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for AdmissionVitalSignsRequest
 */
export namespace AdmissionVitalSignsRequest {
    /**
     * AdmissionVitalSignsRequest Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The mass in kg of the patient.
         * @dataFormat double
         */
        weightInKg: number;
        /**
         * The height in cm of the patient.
         * @dataFormat double
         */
        heightInCm: number;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * AdmissionVitalSignsRequest DTO
     * Transforms AdmissionVitalSignsRequest model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend AdmissionVitalSignsRequest model */
        static toModel(obj: AdmissionVitalSignsRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend AdmissionVitalSignsRequest model */
        static toApi(obj: Model): AdmissionVitalSignsRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as AdmissionVitalSignsRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
